// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The Modal (background) */
.modal {
    display: none; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
}

/* Modal Content/Box */
.modal-content {
    position: relative;
    background-color: #fefefe;
    margin: 0 auto; /* Center horizontally if flexbox is not supported */
    padding: 10px;
    border: 1px solid #888;
    width: 90%; /* Could be more or less, depending on screen size */
    max-height: 90%; /* Ensure it doesn't exceed the screen height */
    box-sizing: border-box; /* Include padding and border in the element's total width and height */
    overflow: auto; /* Add scrolling if the content exceeds the height */
}

/* The Close Button */
.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modal.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI,aAAa,EAAE,sBAAsB;IACrC,eAAe,EAAE,kBAAkB;IACnC,UAAU,EAAE,eAAe;IAC3B,OAAO;IACP,MAAM;IACN,WAAW,EAAE,eAAe;IAC5B,YAAY,EAAE,gBAAgB;IAC9B,cAAc,EAAE,4BAA4B;IAC5C,4BAA4B,EAAE,mBAAmB;IACjD,iCAAiC,EAAE,qBAAqB;IACxD,uBAAuB,EAAE,wBAAwB;IACjD,mBAAmB,EAAE,sBAAsB;AAC/C;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,yBAAyB;IACzB,cAAc,EAAE,oDAAoD;IACpE,aAAa;IACb,sBAAsB;IACtB,UAAU,EAAE,oDAAoD;IAChE,eAAe,EAAE,+CAA+C;IAChE,sBAAsB,EAAE,uEAAuE;IAC/F,cAAc,EAAE,oDAAoD;AACxE;;AAEA,qBAAqB;AACrB;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,YAAY;IACZ,qBAAqB;IACrB,eAAe;AACnB","sourcesContent":["/* The Modal (background) */\n.modal {\n    display: none; /* Hidden by default */\n    position: fixed; /* Stay in place */\n    z-index: 1; /* Sit on top */\n    left: 0;\n    top: 0;\n    width: 100%; /* Full width */\n    height: 100%; /* Full height */\n    overflow: auto; /* Enable scroll if needed */\n    background-color: rgb(0,0,0); /* Fallback color */\n    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */\n    justify-content: center; /* Center horizontally */\n    align-items: center; /* Center vertically */\n}\n\n/* Modal Content/Box */\n.modal-content {\n    position: relative;\n    background-color: #fefefe;\n    margin: 0 auto; /* Center horizontally if flexbox is not supported */\n    padding: 10px;\n    border: 1px solid #888;\n    width: 90%; /* Could be more or less, depending on screen size */\n    max-height: 90%; /* Ensure it doesn't exceed the screen height */\n    box-sizing: border-box; /* Include padding and border in the element's total width and height */\n    overflow: auto; /* Add scrolling if the content exceeds the height */\n}\n\n/* The Close Button */\n.close {\n    color: #aaa;\n    float: right;\n    font-size: 28px;\n    font-weight: bold;\n}\n\n.close:hover,\n.close:focus {\n    color: black;\n    text-decoration: none;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
